// The heading of the calculator form card on /lal-kitab-kundli and
// /hi/lal-kitab-kundli. It is indexed page copy, not a control: on /hi/ it
// stays Devanagari, the script the page still ranks for (owner decision
// 2026-10-08). The card's controls are the governed Hinglish in
// ./_form-copy.ts, which tests/hindi-register.test.ts scans whole-file, so
// the heading lives here.
export const LAL_KITAB_FORM_HEADING = {
  en: "Your birth details",
  hi: "आपका जन्म विवरण",
} as const;
